<template>
  <div>
    Waiting...
    <div id="myspinner"></div>
  </div>
</template>

<script>
import Amplify from 'aws-amplify';
import { Spinner } from '@/services/spinner';
import userInfo from '@/services/userInfo';
import utils from '@/services/utils';

export default {
  name: 'confirm',

  async mounted() {
    // based on:
    // verificationbucket-dev.s3-website-us-east-1.amazonaws.com/verify.js

    // Spinner opts
    // const opts = {
    //   lines: 13, // The number of lines to draw
    //   length: 38, // The length of each line
    //   width: 17, // The line thickness
    //   radius: 45, // The radius of the inner circle
    //   scale: 1, // Scales overall size of the spinner
    //   corners: 1, // Corner roundness (0..1)
    //   color: '#ffffff', // CSS color or array of colors
    //   fadeColor: 'transparent', // CSS color or array of colors
    //   speed: 1, // Rounds per second
    //   rotate: 0, // The rotation offset
    //   animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
    //   direction: 1, // 1: clockwise, -1: counterclockwise
    //   zIndex: 2e9, // The z-index (defaults to 2000000000)
    //   className: 'spinner', // The CSS class to assign to the spinner
    //   top: '50%', // Top position relative to parent
    //   left: '50%', // Left position relative to parent
    //   shadow: '0 0 1px transparent', // Box-shadow for the lines
    //   position: 'absolute', // Element positioning
    // };

    const target = document.getElementById('myspinner');
    new Spinner().spin(target);

    const urlParams = new URLSearchParams(window.location.search);
    const encoded = urlParams.get('data');
    const code = urlParams.get('code');

    const config = Amplify.configure({});
    // console.log('Current config: ', config);

    if (!encoded) {
      console.log('Cant verify - parameters not found');
      return;
    }
    const decoded = JSON.parse(atob(encoded));
    console.log('Decoded: ', decoded);
    const { userName /* , redirectUrl, clientId , region */ } = decoded;

    const params = {
      ClientId: config.aws_user_pools_web_client_id,
      ConfirmationCode: code,
      Username: userName,
    };

    // AWS.config.region = region;

    // eslint-disable-next-line no-undef
    const cogISP = new AWS.CognitoIdentityServiceProvider({
      region: config.aws_cognito_region,
    });

    const cmp = this;

    cogISP.confirmSignUp(params, async (err /* , data */) => {
      // console.log('confirmSignup - data: ', data);
      if (err) {
        // console.log('Error with confirmSignUp', err);
        if (
          err.message
          && err.message.match(/Current status[\w :]* CONFIRMED/)
        ) {
          utils.setStatusMsg(
            this,
            'Account already verified. Please sign-in to continue.',
          );
          // window.location.replace(config.oauth.redirectSignIn);
          cmp.$router.push('/home');
        } else {
          utils.setStatusMsg(this, `Unexpected error: ${err.message}`);
        }
      } else {
        utils.log('Creating new user');
        await userInfo.createNewUserUsingSync(userName);

        utils.setStatusMsg(
          this,
          'Account verified! Please sign-in to continue.',
        );
        // window.location.replace(config.oauth.redirectSignIn);
        cmp.$router.push('/home');
      }
    });
  },
};
</script>

<style>
@keyframes spinner-line-fade-more {
  0%,
  100% {
    opacity: 0; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
@keyframes spinner-line-fade-quick {
  0%,
  39%,
  100% {
    opacity: 0.25; /* minimum opacity */
  }
  40% {
    opacity: 1;
  }
}
@keyframes spinner-line-fade-default {
  0%,
  100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
</style>
